export class GoustoException extends Error {
  data: Record<string, unknown>

  error: string

  level: string

  constructor(
    message: unknown,
    {
      error = '',
      level = 'error',
      ...rest
    }: { error?: string; level?: string; [k: string]: unknown } = {},
  ) {
    super(message as any)
    Object.setPrototypeOf(this, GoustoException.prototype)
    this.data = { ...rest }
    this.error = error
    this.level = level
    this.name = this.constructor.name
  }
}
